import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { browserOf, commandKeys, os } from '../app/platform';

/**
 * The control room's events, in the phone's shape (AnalyticsService.track): `analytics/{businessId}/events`, which the
 * rules let an owner add to and nobody change, kept 14 months by the daily job. Each says which computer and browser it
 * came from. Counts, kinds and buckets only: never addresses, names, numbers or what was typed.
 */
const session = typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : String(Date.now());

const context = () => ({
  platform: 'web',
  app: 'control-room',
  os,
  browser: typeof navigator === 'undefined' ? 'other' : browserOf(navigator.userAgent),
  shortcut: commandKeys,
  locale: typeof navigator === 'undefined' ? '' : navigator.language,
  app_version: import.meta.env.VITE_APP_VERSION ?? 'dev',
});

export function track(event: string, properties: Record<string, string | number | boolean> = {}): void {
  const uid = auth.currentUser?.uid;
  if (!uid) return;
  // An owner's business is keyed by their own id: their events go under it, as the phone's do.
  void addDoc(collection(db, 'analytics', uid, 'events'), {
    event_name: event,
    user_id: uid,
    business_id: uid,
    session_id: session,
    is_guest: false,
    properties,
    device_context: context(),
    timestamp: serverTimestamp(),
    client_timestamp: new Date().toISOString(),
  }).catch(() => {
    // Never in the owner's way: an event that can't be written is dropped.
  });
}

/** How many stops, as a bucket ("1", "2-5", "6-10", "11-25", "26+"): the size, never the list. */
export const stopsBucket = (n: number) => (n <= 1 ? '1' : n <= 5 ? '2-5' : n <= 10 ? '6-10' : n <= 25 ? '11-25' : '26+');
